export function insert(string, what, index) {
    return index > 0
        ? string.replace(new RegExp('.{' + index + '}'), '$&' + what)
        : what + string;
}

export function formatTelMask(phone) {
    if (!phone) return '';
    const firstStep = insert(phone, '  ', 3);
    const finalStep = insert(firstStep, '  ', 8);
    return finalStep;
}

export function formatTelMaskUK(phone) {
    if (!phone) return '';
    const firstStep = insert(phone, '  ', 4);
    const finalStep = insert(firstStep, '  ', 9);
    return finalStep;
}

export function removeSpaces(string) {
    return string.replace(/ /g, '');
}

export function toCamelCase(str) {
    return str.split(' ').map((word, index) => {
        if (index === 0) {
            return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join('');
}

export function capitalize(str) {
    return str.split(' ').map(word =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}


// WEBPACK FOOTER //
// ./src/common/utils/strings.js